import React, { Component, Fragment } from 'react';
import history from '../../../utils/history';

import Modal from '../../common/Modal';
import LargeCheckmarkIcon from '../../icons/LargeCheckmarkIcon';
import InputErrors from '../../common/InputErrors';

class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
      showSuccess: false,
      passwordsMatchError: false,
      noOldPasswordError: false,
      noNewPassword1Error: false,
      noNewPassword2Error: false,
      serverErrors: [],
    };
  }

  handleChange = (e) => {
    const { value, name } = e.target;
    this.setState({ [name]: value });
  }

  submit = (e) => {
    const { oldPassword, newPassword1, newPassword2 } = this.state;
    const { usersActions } = this.props;

    e.preventDefault();
    this.resetErrors();
    if (!oldPassword) {
      this.setState({ noOldPasswordError: true });
    } else if (!newPassword1) {
      this.setState({ noNewPassword1Error: true });
    } else if (!newPassword2) {
      this.setState({ noNewPassword2Error: true });
    } else if (newPassword1 !== newPassword2) {
      this.setState({ passwordsMatchError: true });
    } else {
      usersActions.changePassword({
        oldPassword,
        newPassword: newPassword1,
      }, this.onSuccess, this.onFail);
    }
  }

  onSuccess = () => {
    this.setState({
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
      showSuccess: true,
    });
    document.querySelector('.ReactModal__Content').focus(); // keep focus inside the modal
  }

  onFail = (error) => {
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem connecting to the server.'],
    });
  }

  resetErrors = () => {
    this.setState({
      passwordsMatchError: false,
      noOldPasswordError: false,
      noNewPassword1Error: false,
      noNewPassword2Error: false,
      serverErrors: [],
    });
  }

  closeModal = () => {
    const { toggleChangePasswordModal } = this.props;
    this.resetErrors();
    this.setState({ showSuccess: false });
    toggleChangePasswordModal();
  }

  onForgotPasswordClick = () => {
    // This is a button instead of a link since we need to reset the body styles before navigating
    this.closeModal();
    history.push('/forgot-password');
  }

  render() {
    const { serverErrors, noOldPasswordError, noNewPassword1Error, noNewPassword2Error, passwordsMatchError, showSuccess, oldPassword, newPassword1, newPassword2 } = this.state;
    const { visible } = this.props;
    let errors = serverErrors;
    if (noOldPasswordError || noNewPassword1Error || noNewPassword2Error) errors = [...errors, 'All fields are required.'];
    if (passwordsMatchError) errors = [...errors, 'Your new passwords must match.'];
    return (
      <Modal
        toggleModal={this.closeModal}
        visible={visible}
        centered
      >
        {showSuccess
          ? (
            <div className="text">
              <h2>
                Your Password Has
                <br />
                Been Changed
              </h2>
              <div className="modal__checkmark-icon">
                <LargeCheckmarkIcon />
              </div>
              <button
                type="button"
                onClick={this.closeModal}
                className="button"
              >
                Back to Account
              </button>
            </div>
          ) : (
            <Fragment>
              <div className="text">
                <h2>
                  Change Password
                </h2>
                <p>
                  Please create a new password.
                </p>
              </div>
              <form className="form form--modal">
                {errors.length !== 0 && <InputErrors errors={errors} />}
                <label className="form__text-label" htmlFor="input-old-password">
                  Current Password
                </label>
                <input
                  id="input-old-password"
                  name="oldPassword"
                  value={oldPassword}
                  onChange={this.handleChange}
                  type="password"
                />
                <label className="form__text-label" htmlFor="input-new-password-1">
                  New Password
                </label>
                <input
                  id="input-new-password-1"
                  name="newPassword1"
                  value={newPassword1}
                  onChange={this.handleChange}
                  type="password"
                />
                <label className="form__text-label" htmlFor="input-new-password-2">
                  Confirm New Password
                </label>
                <input
                  id="input-new-password-2"
                  name="newPassword2"
                  value={newPassword2}
                  onChange={this.handleChange}
                  type="password"
                />
                <div className="form__options">
                  <button
                    type="button"
                    className="flat-link-from-button"
                    onClick={this.onForgotPasswordClick}
                  >
                    Forgot password?
                  </button>
                </div>
                <div className="form__submit-button-wrapper">
                  <button
                    type="submit"
                    onClick={this.submit}
                    className="button"
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </Fragment>
          )}
      </Modal>
    );
  }
}

export default ChangePasswordModal;



// WEBPACK FOOTER //
// ./src/components/features/account/ChangePasswordModal.js